import { Container, Grid, Paper, Typography, Box } from '@mui/material'
import SeeNotice from '../../components/SeeNotice';
import Students from "../../assets/img1.png";
import Classes from "../../assets/img2.png";
import Teachers from "../../assets/img3.png";
import Fees from "../../assets/img4.png";
import styled from 'styled-components';
import CountUp from 'react-countup';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import { getAllSclasses } from '../../redux/sclassRelated/sclassHandle';
import { getAllStudents } from '../../redux/studentRelated/studentHandle';
import { getAllTeachers } from '../../redux/teacherRelated/teacherHandle';
import { motion } from 'framer-motion';

const AdminHomePage = () => {
    const dispatch = useDispatch();
    const { studentsList } = useSelector((state) => state.student);
    const { sclassesList } = useSelector((state) => state.sclass);
    const { teachersList } = useSelector((state) => state.teacher);

    const { currentUser } = useSelector(state => state.user)

    const adminID = currentUser._id

    useEffect(() => {
        dispatch(getAllStudents(adminID));
        dispatch(getAllSclasses(adminID, "Sclass"));
        dispatch(getAllTeachers(adminID));
    }, [adminID, dispatch]);

    const numberOfStudents = studentsList && studentsList.length;
    const numberOfClasses = sclassesList && sclassesList.length;
    const numberOfTeachers = teachersList && teachersList.length;

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.1
            }
        }
    };

    const itemVariants = {
        hidden: { y: 20, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1,
            transition: { duration: 0.5 }
        }
    };

    return (
        <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
            <motion.div variants={containerVariants} initial="hidden" animate="visible">
                <Box sx={{ mb: 4 }}>
                    <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#0A192F' }}>
                        Welcome back, Administrator {currentUser?.name}! 🚀
                    </Typography>
                    <Typography variant="subtitle1" sx={{ color: 'text.secondary' }}>
                        Here is the institute overview for today.
                    </Typography>
                </Box>
                
                <Grid container spacing={4}>
                    <Grid item xs={12} sm={6} md={3}>
                        <motion.div variants={itemVariants}>
                            <StyledPaper elevation={3}>
                                <IconWrapper sx={{ background: 'rgba(255, 153, 51, 0.1)' }}>
                                    <img src={Students} alt="Students" style={{ width: '50px' }} />
                                </IconWrapper>
                                <Box>
                                    <Title>Total Students</Title>
                                    <Data start={0} end={numberOfStudents || 0} duration={2} />
                                </Box>
                            </StyledPaper>
                        </motion.div>
                    </Grid>
                    
                    <Grid item xs={12} sm={6} md={3}>
                        <motion.div variants={itemVariants}>
                            <StyledPaper elevation={3}>
                                <IconWrapper sx={{ background: 'rgba(10, 25, 47, 0.05)' }}>
                                    <img src={Classes} alt="Classes" style={{ width: '50px' }} />
                                </IconWrapper>
                                <Box>
                                    <Title>Total Classes</Title>
                                    <Data start={0} end={numberOfClasses || 0} duration={2} />
                                </Box>
                            </StyledPaper>
                        </motion.div>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <motion.div variants={itemVariants}>
                            <StyledPaper elevation={3}>
                                <IconWrapper sx={{ background: 'rgba(255, 153, 51, 0.1)' }}>
                                    <img src={Teachers} alt="Teachers" style={{ width: '50px' }} />
                                </IconWrapper>
                                <Box>
                                    <Title>Total Teachers</Title>
                                    <Data start={0} end={numberOfTeachers || 0} duration={2} />
                                </Box>
                            </StyledPaper>
                        </motion.div>
                    </Grid>

                    <Grid item xs={12} sm={6} md={3}>
                        <motion.div variants={itemVariants}>
                            <StyledPaper elevation={3}>
                                <IconWrapper sx={{ background: 'rgba(10, 25, 47, 0.05)' }}>
                                    <img src={Fees} alt="Fees" style={{ width: '50px' }} />
                                </IconWrapper>
                                <Box>
                                    <Title>Fees Collected</Title>
                                    <Data start={0} end={2300000} duration={2.5} prefix="₹" />                        
                                </Box>
                            </StyledPaper>
                        </motion.div>
                    </Grid>

                    <Grid item xs={12}>
                        <motion.div variants={itemVariants}>
                            <Paper elevation={3} sx={{ p: 3, borderRadius: '16px' }}>
                                <Typography variant="h5" sx={{ mb: 3, fontWeight: 'bold', color: '#0A192F' }}>
                                    Institute Notices
                                </Typography>
                                <SeeNotice />
                            </Paper>
                        </motion.div>
                    </Grid>
                </Grid>
            </motion.div>
        </Container>
    );
};

const StyledPaper = styled(Paper)`
  padding: 24px;
  display: flex;
  height: 160px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
  border-radius: 16px !important;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  text-align: center;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 12px 24px rgba(0,0,0,0.1) !important;
  }
`;

const IconWrapper = styled(Box)`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Title = styled.p`
  font-size: 1.1rem;
  color: #64748B;
  margin: 0;
  font-weight: 500;
`;

const Data = styled(CountUp)`
  font-size: 2rem;
  font-weight: 700;
  color: #0A192F;
  margin-top: 5px;
`;

export default AdminHomePage